import React from "react";
import { IconChevronRight } from "@tabler/icons-react";
import MOptionsMenu, {
  DropdownOption,
} from "@/components/ui/atoms/MOptionsMenu";
import styles from "./reminder.module.css";

export interface ReminderCardProps {
  icon: React.ReactNode;
  badgeLabel: string;
  isOwn: boolean;
  title: string;
  onTitleClick?: () => void;
  secondaryText?: string;
  secondaryIcon?: React.ReactNode;
  tertiaryText?: string;
  tertiaryIcon?: React.ReactNode;
  actions: DropdownOption[];
}

const ReminderCard: React.FC<ReminderCardProps> = ({
  icon,
  badgeLabel,
  isOwn,
  title,
  onTitleClick,
  secondaryText,
  secondaryIcon,
  tertiaryText,
  tertiaryIcon,
  actions,
}) => {
  return (
    <div
      className={styles.cardRow}
      onClick={onTitleClick}
      role={onTitleClick ? "button" : undefined}
    >
      <div className={styles.cardIconSquare}>{icon}</div>
      <div className={styles.cardBody}>
        <span className={isOwn ? styles.badgeOwn : styles.badgeFamily}>
          {badgeLabel}
        </span>
        <div className={styles.cardTitleRow}>
          <span className={styles.cardTitle}>{title}</span>
          <IconChevronRight size={16} className={styles.cardChevron} />
        </div>
        {secondaryText && (
          <div className={styles.cardSecondaryRow}>
            {secondaryIcon}
            <span className={styles.cardSecondaryText}>{secondaryText}</span>
          </div>
        )}
        {tertiaryText && (
          <div className={styles.cardTertiaryRow}>
            {tertiaryIcon}
            <span className={styles.cardTertiaryText}>{tertiaryText}</span>
          </div>
        )}
      </div>
      {/* Stop the row's own click from firing when the 3-dot menu (or its
          dropdown items, portaled elsewhere in the DOM but still bubbling
          through this React tree) is what was actually tapped. */}
      <div className={styles.cardActions} onClick={(e) => e.stopPropagation()}>
        <MOptionsMenu options={actions} iconSize={20} />
      </div>
    </div>
  );
};

export default ReminderCard;
